module.exports = __webpack_public_path__ + "static/img/Bercy-Arena-Basketball.25ea1fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bercy-Arena-Basketball.jpg
// module id = me/Z
// module chunks = 0